import styled, { css } from 'styled-components'

interface TopBarProps {
  isFiltered: boolean
}

export const Wrapper = styled.div`
  ${({ theme }) => css`
    border-radius: ${theme.ds.typography.border.radius.small};
    overflow: hidden;
    transition: ${theme.transition.default};
    box-shadow: ${theme.ds.shadows.satin};
    background-color: ${theme.ds.colors.neutral25};
    height: 160px;
    display: flex;
    flex-direction: column;
  `}
`

export const TopBar = styled.div<TopBarProps>`
  ${({ isFiltered }) => css`
    height: 8px;
    background: ${isFiltered ? '#FF8D004D' : '#9C27B04D'};
  `}
`

export const Code = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.ds.typography.fontFamilySecondary};
    font-size: ${theme.ds.typography.size.xsmall};
    font-weight: ${theme.ds.typography.weight.normal};
    color: ${theme.ds.colors.textSecondary};
  `}
`

export const Description = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.ds.typography.size.xsmall};
    font-weight: ${theme.ds.typography.weight.bold};
    color: ${theme.ds.colors.textPrimary};
  `}
`

export const SelectButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
    border: none;
    padding: 0;
    font-size: ${theme.ds.typography.size.xxsmall};
    font-weight: ${theme.ds.typography.weight.bold};
    color: ${theme.ds.colors.primary600};
    cursor: pointer;
    transition: ${theme.transition.default};
    margin-top: auto;
  `}
`

export const ArrowIconWrapper = styled.span`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    svg {
      width: 8px;
      height: 12px;

      path {
        stroke: ${theme.ds.colors.primary600};
      }
    }
  `}
`
